/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-unused-vars */
/* eslint-disable import/prefer-default-export */
import {
  buildingIcon,
  hornIcon,
  settingsIcon,
  userIcon,
  scheduleIcon,
  availIcon,
  networkIcon,
  pinIcon,
  cablesIcon,
  globeIcon,
  atomsIcon,
  filmTicketIcon,
  envelopeWhiteIcon,
  programme,
  cableIcon,
  demographicsIcon,
  contactIcon,
  creativesIcon,
  traffickingIcon,
  instructionsIcon,
  orderManagementIcon,
  clientsIcon,
  invoiceIcon,
  reachParameterIcon,
  businessRulesIcon,
  businessRulesListIcon,
  customBusinessRulesIcon,
  agencyCommissionIcon,
  orderAllIcon,
  orderWithoutTrafficIcon,
  orderWithoutInvoiceIcon,
  orderVersionHistoryIcon,
} from '../../assets';

const superAdminNavigations = [
  {
    id: 1,
    title: 'Organizations',
    path: '/organisations',
    icon: buildingIcon,
  },
  {
    id: 2,
    title: 'Users',
    path: '/users',
    icon: userIcon,
  },
  {
    id: 3,
    title: 'Business Rules',
    collapsible: true,
    icon: businessRulesIcon,
    subLinks: [
      {
        id: 1,
        subTitle: 'List',
        path: '/business-rules',
        icon: businessRulesListIcon,
      },
      {
        id: 2,
        subTitle: 'Values',
        path: '/custom-business-rules',
        icon: customBusinessRulesIcon,
      },
    ],
  },
  {
    id: 4,
    title: 'Settings',
    collapsible: true,
    icon: settingsIcon,
    subLinks: [
      {
        id: 1,
        subTitle: 'Email Triggers',
        path: '/email-trigger',
        icon: envelopeWhiteIcon,
      },
      {
        id: 2,
        subTitle: 'Reach Parameter',
        path: '/reach-parameter',
        icon: reachParameterIcon,
      },
      {
        id: 3,
        subTitle: 'Markets',
        path: '/data-management/markets',
        icon: pinIcon,
      },
      {
        id: 4,
        subTitle: 'Networks',
        path: '/data-management/networks',
        icon: networkIcon,
      },
      {
        id: 5,
        subTitle: 'Stations/Cables',
        path: '/data-management/stations',
        icon: cableIcon,
      },
      {
        id: 6,
        subTitle: 'Demographics',
        path: '/data-management/demographics',
        icon: demographicsIcon,
      },
    ],
  },
];

const organisationalAdminNavigations = [
  {
    id: 1,
    title: 'Campaigns',
    path: '/campaigns',
    icon: hornIcon,
  },
  {
    id: 2,
    title: 'Orders',
    collapsible: true,
    icon: orderManagementIcon,
    subLinks: [
      {
        id: 1,
        subTitle: 'All Orders',
        path: '/orders',
        icon: orderAllIcon,
      },
      {
        id: 2,
        subTitle: 'Without Traffic',
        path: '/orders-without-traffic',
        icon: orderWithoutTrafficIcon,
      },
      {
        id: 3,
        subTitle: 'Without Invoice',
        path: '/orders-without-invoice',
        icon: orderWithoutInvoiceIcon,
      },
      {
        id: 4,
        subTitle: 'Version History',
        path: '/orders-version-history',
        icon: orderVersionHistoryIcon,
      },
    ],
  },
  {
    id: 3,
    title: 'Contact Management',
    path: '/contacts',
    icon: contactIcon,
  },
  {
    id: 4,
    title: 'Trafficking',
    collapsible: true,
    icon: traffickingIcon,
    subLinks: [
      {
        id: 1,
        subTitle: 'Creatives',
        path: '/trafficking/creatives',
        icon: creativesIcon,
      },
      {
        id: 2,
        subTitle: 'Instructions',
        path: '/trafficking/instructions',
        icon: instructionsIcon,
      },
    ],
  },
  {
    id: 5,
    title: 'Invoices',
    path: '/invoices',
    icon: invoiceIcon,
  },
  {
    id: 6,
    title: 'Program Filters',
    path: '/programme',
    icon: programme,
  },
  {
    id: 7,
    title: 'Settings',
    collapsible: true,
    icon: settingsIcon,
    subLinks: [
      {
        id: 1,
        subTitle: 'Users',
        path: '/users',
        icon: userIcon,
      },
      {
        id: 2,
        subTitle: 'Clients',
        path: '/data-management/clients',
        icon: clientsIcon,
      },
      {
        id: 3,
        subTitle: 'Markets',
        path: '/data-management/markets',
        icon: pinIcon,
      },
      {
        id: 4,
        subTitle: 'Stations/Cables',
        path: '/data-management/stations',
        icon: cableIcon,
      },
      {
        id: 5,
        subTitle: 'Demographics',
        path: '/data-management/demographics',
        icon: demographicsIcon,
      },
      {
        id: 6,
        subTitle: 'Agency Commission',
        path: '/agency-commission',
        icon: agencyCommissionIcon,
      },
    ],
  },
];

const organisationalUserNavigations = [
  {
    id: 1,
    title: 'Campaigns',
    path: '/campaigns',
    icon: hornIcon,
  },
  {
    id: 2,
    title: 'Orders',
    collapsible: true,
    icon: orderManagementIcon,
    subLinks: [
      {
        id: 1,
        subTitle: 'All Orders',
        path: '/orders',
        icon: orderAllIcon,
      },
      {
        id: 2,
        subTitle: 'Without Traffic',
        path: '/orders-without-traffic',
        icon: orderWithoutTrafficIcon,
      },
      {
        id: 3,
        subTitle: 'Without Invoice',
        path: '/orders-without-invoice',
        icon: orderWithoutInvoiceIcon,
      },
      {
        id: 4,
        subTitle: 'Version History',
        path: '/orders-version-history',
        icon: orderVersionHistoryIcon,
      },
    ],
  },
  {
    id: 3,
    title: 'Contact Management',
    path: '/contacts',
    icon: contactIcon,
  },
  {
    id: 4,
    title: 'Trafficking',
    collapsible: true,
    icon: traffickingIcon,
    subLinks: [
      {
        id: 1,
        subTitle: 'Creatives',
        path: '/trafficking/creatives',
        icon: creativesIcon,
      },
      {
        id: 2,
        subTitle: 'Instructions',
        path: '/trafficking/instructions',
        icon: instructionsIcon,
      },
    ],
  },
  {
    id: 5,
    title: 'Invoices',
    path: '/invoices',
    icon: invoiceIcon,
  },
  {
    id: 6,
    title: 'Programme Filters',
    path: '/programme',
    icon: programme,
  },
];

export {
  superAdminNavigations,
  organisationalAdminNavigations,
  organisationalUserNavigations,
};
